import { Component, OnInit } from '@angular/core';
import { Company } from '../../classes/company';
import { CompanyService } from '../../services/company.service';
import { NgForm } from '@angular/forms';
import { Router } from "@angular/router";
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-multiple-companies-page',
  templateUrl: './multiple-companies-page.component.html',
  styleUrls: ['./multiple-companies-page.component.scss']
})
export class MultipleCompaniesPageComponent implements OnInit {

  constructor(private CompanyService: CompanyService, private router: Router, private titleService: Title) { }

  ngOnInit() {
    this.getCompanies();
    let u: string = JSON.parse(localStorage.onboardingUser).user;
    this.name = JSON.parse(u).first_name;
    this.titleService.setTitle('Companies');
  }

  companies: Company[] = [];
  company: Company = <Company>{};
  name: string = '';

  getCompanies() {
    this.CompanyService.getCompanies()
      .subscribe(companies => {
        console.log(companies)
        this.companies = JSON.parse(companies.organizations);
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  addCompany(companyForm: NgForm) {
    if (companyForm.invalid) {
      return;
    }
    console.log(this.company)
    this.CompanyService.addCompany(this.company)
      .subscribe(companies => {
        this.getCompanies();
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  removeCompany(id: number) {
    this.CompanyService.deleteCompany(id)
      .subscribe(companies => {
        this.getCompanies();
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  redirect(orgId: number) {
    localStorage.currentOrgId = orgId;
    this.router.navigate(['/onboarding/dashboard/multiple', orgId]);
  }

}



// WEBPACK FOOTER //
// ./src/app/onboarding/components/multiple-companies-page/multiple-companies-page.component.ts